import React from "react";
import ExpandableList from "@/bit/components/components.expandable-list";

const ExpandableTextListCompo = (props) => {
  const expandableListKeys = Object.keys(props).filter((key) => /^Expandable-Item-\d+$/.test(key));
  const expandableListValues = expandableListKeys.map((key) => props[key]);

  return (
    <section className="ExpandableTextListCompo container" data-cy="Section Expandable List">
      <ExpandableList itemsList={expandableListValues} />
      <style jsx>
        {`
          .ExpandableTextListCompo {
            margin-bottom: 2rem;
          }
        `}
      </style>
    </section>
  );
};

export default ExpandableTextListCompo;
